export const skillsData = [
    'HTML',
    'Javascript',
    'CSS',
    'React',
    "Redux",
    "Sass",
    "Github",
    "Wave",
    "Lighthouse"
    
]
